module.exports = __webpack_public_path__ + "img/icon_11.4f752b91.png";